import axios from 'axios'
import ConfigConstants from '@/constants/Config.constants'
import { Response, ToolboxItem, Expression, PaginationQueryParameters } from '@/models'
import { IGlobalFiltersToolboxService } from '../IGlobalFiltersToolboxService'

export default class GlobalFilterToolboxService implements IGlobalFiltersToolboxService {
  private endpointUrl: string

  private readonly options = {
    headers: {
      'Content-Type': ConfigConstants.CONTENT_TYPES.YT_V1,
      Accept: '*/*',
    },
  } as const

  constructor(endpointUrl: string) {
    this.endpointUrl = endpointUrl
  }

  public async getToolboxItems(
    projectId: number,
    params?: PaginationQueryParameters,
  ): Promise<Response<ToolboxItem[]>> {
    return axios
      .get<
        Response<ToolboxItem[]>
      >(`${this.endpointUrl}/project/${projectId}/global-filter-toolbox`, { params, ...this.options })
      .then((response) => response.data)
  }

  public async getToolboxItemsForExpression(
    projectId: number,
    expression: Expression,
    params?: PaginationQueryParameters,
  ): Promise<Response<ToolboxItem[]>> {
    return axios
      .post<
        Response<ToolboxItem[]>
      >(`${this.endpointUrl}/project/${projectId}/global-filter-toolbox`, { data: expression }, { params, ...this.options })
      .then((response) => response.data)
  }
}
